import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { SummaryState, addonState, addonsState, ObjectivesState, sidebarState } from './storeStates';
import { IAddon } from '../services/AddonsService';

const objectivesStore = create<ObjectivesState>()(
  persist(
    (set) => ({
      legalPersonalitySlug: undefined,
      objectives: [],
      jurisdictionType: '',
      setLegalPersonalitySlug: (legalPersonalitySlug?: string) => set({ legalPersonalitySlug }),
      setObjectives: (objectives: string[]) => set({ objectives }),
      setJurisdictionType: (jurisdictionType: string) => set({ jurisdictionType })
    }),
    {
      name: 'bear-storage'
    }
  )
);

const addonsStore = create<addonsState>()(
  persist(
    (set) => ({
      addons: [],
      setAddons: (addons: addonState[]) => set({ addons })
    }),
    {
      name: 'bear-storage'
    }
  )
);

const sidebarStore = create<sidebarState>()(
  persist(
    (set) => ({
      isOpen: false,
      toggle: () => set((state) => ({ isOpen: !state.isOpen }))
    }),
    {
      name: 'bear-storage'
    }
  )
);

const summaryStore = create<SummaryState>()((set) => ({
  addons: [],
  setAddons: (addons: IAddon[]) => set({ addons })
}));

export { addonsStore, objectivesStore, sidebarStore, summaryStore };
